module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('h3', [_vm._v("Assortiment")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.assortiment), function(item) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n        " + _vm._s(item.naam) + "\n      ")])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Shop")]), _vm._v(" "), _c('p', [_vm._v("We hebben eerder een webshop actief gehad, maar juist voor de jeugdwerk is eigenlijk alles maatwerk.")]), _vm._v(" "), _c('p', [_vm._v("Daarom hebben we ervoor gekozen geen webshop meer actief te hebben, maar dat betekent niet dat we geen \n        jeugd-specifieke artikelen meer kunnen leveren.")]), _vm._v(" "), _c('p', [_vm._v("Neem contact met mij op via info@fietsenmetvictor.nl of +31 85 30 11 500 als je op zoek bent naar een \n          bepaald onderdeel of een oplossing. ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a018b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop.vue
// module id = 17
// module chunks = 0